export default "__VITE_ASSET__bd8b5ebe__"